<template>
  <layouts-header></layouts-header>

  <!-- Breadcrumb -->
  <div class="breadcrumb-bar text-center">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-12">
          <h2 class="breadcrumb-title mb-2">{{ pageTitle }}</h2>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb justify-content-center mb-0">
              <li class="breadcrumb-item">
                <router-link to="/home">Home</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                {{ pageTitle }}
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <!-- Course add -->

  <div class="content">
    <div class="container">
      <div class="row">
        <div class="col-lg-10 mx-auto">
          <div class="add-course-item">
            <!-- header card add new course -->
            <div class="wizard">
              <!-- header 1 step add new course -->
              <ul
                class="form-wizard-steps"
                id="progressbar2"
                v-show="currentStep === 1"
              >
                <li class="progress-active">
                  <div class="profile-step">
                    <span class="dot-active mb-2">
                      <span class="number">01</span>
                      <span class="tickmark"
                        ><i class="fa-solid fa-check"></i
                      ></span>
                    </span>
                    <div class="step-section">
                      <p>Course Information</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="profile-step">
                    <span class="dot-active mb-2">
                      <span class="number">02</span>
                      <span class="tickmark"
                        ><i class="fa-solid fa-check"></i
                      ></span>
                    </span>
                    <div class="step-section">
                      <p>Course Media</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="profile-step">
                    <span class="dot-active mb-2">
                      <span class="number">03</span>
                      <span class="tickmark"
                        ><i class="fa-solid fa-check"></i
                      ></span>
                    </span>
                    <div class="step-section">
                      <p>Curriculam</p>
                    </div>
                  </div>
                </li>
              </ul>
              <!-- header 1 step add new course -->

              <!-- header 2 step add new course -->
              <ul
                class="form-wizard-steps"
                id="progressbar2"
                v-show="currentStep === 2"
              >
                <li class="progress-activated">
                  <div class="profile-step">
                    <span class="dot-active mb-2">
                      <span class="number">01</span>
                      <span class="tickmark"
                        ><i class="fa-solid fa-check"></i
                      ></span>
                    </span>
                    <div class="step-section">
                      <p>Course Information</p>
                    </div>
                  </div>
                </li>
                <li class="progress-active">
                  <div class="profile-step">
                    <span class="dot-active mb-2">
                      <span class="number">02</span>
                      <span class="tickmark"
                        ><i class="fa-solid fa-check"></i
                      ></span>
                    </span>
                    <div class="step-section">
                      <p>Course Media</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="profile-step">
                    <span class="dot-active mb-2">
                      <span class="number">03</span>
                      <span class="tickmark"
                        ><i class="fa-solid fa-check"></i
                      ></span>
                    </span>
                    <div class="step-section">
                      <p>Curriculam</p>
                    </div>
                  </div>
                </li>
              </ul>
              <!-- header 2 step add new course -->

              <!-- header 3 step add new course -->
              <ul
                class="form-wizard-steps"
                id="progressbar2"
                v-show="currentStep === 3"
              >
                <li class="progress-activated">
                  <div class="profile-step">
                    <span class="dot-active mb-2">
                      <span class="number">01</span>
                      <span class="tickmark"
                        ><i class="fa-solid fa-check"></i
                      ></span>
                    </span>
                    <div class="step-section">
                      <p>Course Information</p>
                    </div>
                  </div>
                </li>
                <li class="progress-activated">
                  <div class="profile-step">
                    <span class="dot-active mb-2">
                      <span class="number">02</span>
                      <span class="tickmark"
                        ><i class="fa-solid fa-check"></i
                      ></span>
                    </span>
                    <div class="step-section">
                      <p>Course Media</p>
                    </div>
                  </div>
                </li>
                <li class="progress-active">
                  <div class="profile-step">
                    <span class="dot-active mb-2">
                      <span class="number">03</span>
                      <span class="tickmark"
                        ><i class="fa-solid fa-check"></i
                      ></span>
                    </span>
                    <div class="step-section">
                      <p>Curriculam</p>
                    </div>
                  </div>
                </li>
              </ul>
              <!-- header 3 step add new course -->
            </div>
            <!-- header card add new course -->

            <div class="initialization-form-set">
              <!-- step pertama -->
              <fieldset
                class="form-inner wizard-form-card"
                id="first"
                v-if="currentStep === 1"
              >
                <course-information></course-information>
                <div
                  class="add-form-btn widget-next-btn submit-btn d-flex justify-content-end mb-0"
                >
                  <div class="btn-left">
                    <a
                      href="javascript:void(0);"
                      @click="nextStep"
                      :disabled="currentStep === totalSteps"
                      class="btn main-btn next_btns"
                      >Next
                      <i class="isax isax-arrow-right-3 ms-1"></i>
                    </a>
                  </div>
                </div>
              </fieldset>
              <!-- step pertama -->

              <!-- step kedua -->
              <fieldset
                class="form-inner wizard-form-card"
                v-if="currentStep === 2"
              >
                <course-media></course-media>
                <div class="add-form-btn widget-next-btn submit-btn">
                  <div class="btn-left">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-light main-btn prev_btns d-flex align-items-center"
                      @click="previousStep"
                      :disabled="currentStep === 1"
                    >
                      <i class="isax isax-arrow-left-2 me-1"></i>Prev
                    </a>
                  </div>
                  <div class="btn-left">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-secondary main-btn next_btns d-flex align-items-center"
                      @click="nextStep"
                      :disabled="currentStep === totalSteps"
                    >
                      Next <i class="isax isax-arrow-right-3 ms-1"></i>
                    </a>
                  </div>
                </div>
              </fieldset>
              <!-- step kedua -->

              <!-- step ketiga -->
              <fieldset
                class="form-inner wizard-form-card"
                v-if="currentStep === 3"
              >
                <course-curriculam></course-curriculam>
                <div class="add-form-btn widget-next-btn submit-btn">
                  <div class="btn-left">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-light main-btn prev_btns"
                      @click="previousStep"
                      :disabled="currentStep === 2"
                    >
                      <i class="isax isax-arrow-left-2 me-1"></i>
                      Prev
                    </a>
                  </div>
                  <!-- <div class="btn-left">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-secondary main-btn next_btns"
                      @click="nextStep"
                      :disabled="currentStep === totalSteps"
                    >
                      Next
                      <i class="isax isax-arrow-right-3 ms-1"></i>
                    </a>
                  </div> -->
                  <div class="btn-left">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-secondary main-btn next_btns"
                      @click="submitCourseHandler"
                    >
                      Submit Course
                    </a>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Course watch -->

  <add-course-modal></add-course-modal>

 <!--  <footer-two></footer-two> -->
  <BaseLoading
    v-if="sharedStore.loading"
    :progress="CourseDataStore.isUploading ? CourseDataStore.uploadProgress : null"
    :status-text="CourseDataStore.uploadStatusText"
  ></BaseLoading>

  <div style="height: 100px"></div>
</template>

<script>
import { useCourseDataStore } from "@/stores/course/course-data-store";
import { Modal } from "bootstrap";
import BaseLoading from "@/components/CustomComponent/shared/Loading.vue";
import { useSharedStore } from "@/stores/shared-store";
import { useAuthStore } from "@/stores/auth-store";
import { useRoute } from "vue-router";

export default {
  props: {
    courseID: {
      type: [String, Number],
      default: null,
    },
  },
  components: {
    BaseLoading,
  },
  data() {
    return {
      currentStep: 1,
      totalSteps: 3,
    };
  },
  computed: {
    targetCourseID() {
      // Jangan pakai prop courseID: saat komponen di-reuse (edit → add),
      // prop bisa menempel dari route sebelumnya.
      return (
        this.$route.params?.courseID ||
        this.$route.params?.id ||
        this.$route.query?.courseID ||
        this.$route.query?.id ||
        null
      );
    },
    isEditMode() {
      return !!(
        this.targetCourseID ||
        this.$route.name === "CourseEdit" ||
        (this.$route.path && this.$route.path.includes("/edit"))
      );
    },
    pageTitle() {
      return this.isEditMode ? "Edit Course" : "Add New Course";
    },
  },
  watch: {
    // Route add ↔ edit memakai komponen yang sama
    "$route.fullPath"() {
      this.syncFormWithRoute();
    },
  },
  created() {
    this.syncFormWithRoute();
  },
  beforeUnmount() {
    this.CourseDataStore.resetCourseForm();
  },
  methods: {
    syncFormWithRoute() {
      this.currentStep = 1;
      if (this.isEditMode && this.targetCourseID) {
        return;
      }
      this.CourseDataStore.resetCourseForm();
    },
    nextStep() {
      if (this.currentStep < this.totalSteps) {
        this.currentStep++;
      }
    },
    previousStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },
    showProgress(step) {
      return this.currentStep === step;
    },

    async submitCourseHandler() {
      try {
        const idToUpdate = this.targetCourseID;
        if (idToUpdate) {
          // === EDIT MODE ===
          await this.CourseDataStore.updateCourseWithContents(idToUpdate);
        } else {
          // === CREATE MODE ===
          await this.CourseDataStore.submitCourseWithContents();
        }
      } catch (error) {
        console.error("Gagal submit course:", error);
        this.sharedStore.showError("Gagal menyimpan course.", error);
      }
    },
  },
  setup() {
    const route = useRoute();
    const CourseDataStore = useCourseDataStore();
    const sharedStore = useSharedStore();
    const authStore = useAuthStore();

    return {
      CourseDataStore,
      sharedStore,
      authStore,
      route,
    };
  },
};
</script>
